import type { ReactNode } from 'react';
import { type StyleProp, type ViewStyle } from 'react-native';
import { Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { createTheme } from 'app/shopify';
const theme = createTheme();

export function RequestImage({
  width = 60,
  height = 60,
  fontSize = 32,
  scale = 1,
  children,
  style,
  isFound,
}: {
  width?: number;
  height?: number;
  fontSize?: number;
  scale?: number;
  children?: ReactNode;
  style?: StyleProp<ViewStyle>;
  isFound?: boolean;
}) {
  return (
    <Row
      alignItems="center"
      justifyContent="center"
      style={[
        {
          backgroundColor: theme.colors['surface.brand.secondary-5.subtle'],
          borderRadius: theme.borderRadii['radius.lg'],
          width: width * scale,
          height: height * scale,
        },
        style,
      ]}
    >
      <Text style={{ fontSize: fontSize * scale, fontWeight: '700' }} lineHeight={fontSize * scale * 1.2}>
        {isFound ? '🤝' : '👋'}
      </Text>
      {children}
    </Row>
  );
}
